<template>
  <li>
    <a :href="link">
      <figure><img :src="pic" :alt="title" loading="lazy" width="400px" height="250px"></figure>
      <div class="box">
        <h4 v-html="title"></h4>
        <p v-html="cate" class="cate"></p>
        <p v-html="description"></p>
      </div>
      <time v-html="date"></time>
      <div class="next">Read more<svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
    </a>
  </li>
</template>

<style lang="scss" scoped>
li{
  @media screen and (max-width: module.$tab){
    margin: 0 0 2rem;
    padding: 0 0 2rem;
    border-bottom: module.$border 1px solid;
    &:last-child{
      margin: 0;
      padding: 0;
      border: none;
    }
  }
  a{
    padding: 0 0 0 2.4rem;
    display: block;
    transition: all 160ms module.$ease;
    transition-property: border, transform;
    position: relative;
    @media screen and (max-width: module.$tab){
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }
    @media screen and (max-width: module.$phone){
      grid-template-columns: 10rem 1fr;
      gap: 1.6rem;
    }
    @media screen and (min-width: calc(#{module.$tab} + 1px)){
      &:hover{
        > figure{
          &:before,
          &:after{
            opacity: 1;
          }
          &:after{
            top: 50%;
          }
          img{
            opacity: 1;  
          }
        }
        .more{
          &:before{
            width: 100%;
          }
        }
      }
    }
    > figure{
      width: 100%;
      padding: calc(100% / 16 * 10) 0 0;
      position: relative;
      border-radius: 1rem;
      overflow: hidden;
      @media screen and (max-width: module.$phone){
        border-radius: .4rem;
      }
      &:before,
      &:after{
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(module.$base,.8);
        z-index: 2;
        opacity: 0;
        transition: all 400ms module.$ease;
        transition-property: opacity, top;
      }
      &:after{
        content: 'More';
        width: auto;
        height: auto;
        background: module.$white;
        border-radius: 999px;
        padding: 6px 32px;
        top: 60%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    time{
      font-size: 1.04rem;
      font-weight: 700;
      position: absolute;
      top: 0;
      left: 0;
      padding-top: 2rem;
      -webkit-writing-mode: vertical-rl;
      -moz-writing-mode: vertical-rl;
      -ms-writing-mode: tb-rl;
      writing-mode: vertical-rl;
      white-space: nowrap;
      -webkit-font-feature-settings: normal;
      font-feature-settings: normal;
      @media screen and (max-width: module.$phone){
        font-size: .72rem;
        padding: 1.2rem 0 0;
      }
      &:before{
        content: '';
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: module.$base;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        @media screen and (max-width: module.$phone){
          width: 7px;
          height: 7px;
        }
      }
    }
    .box{
      position: relative;
      width: 100%;
      h3, h4{
        margin: 1.6rem 0 0;
        font-size: 1.16rem;
        font-weight: 700;
        line-height: 1.56;
        @media screen and (max-width: module.$tab){
          margin: 0;
          padding: 3rem 0 0;
        }
        @media screen and (max-width: module.$phone){
          font-size: 1rem;
        }
      }
      p{
        font-size: .92rem;
        line-height: 1.6;
        margin: .2rem 0 0;
        @media screen and (max-width: module.$tab){
          margin: .8rem 0 0;
        }
        @media screen and (max-width: module.$phone){
          display: none;
        }
      }
      .cate{
        background: module.$border;
        padding: .24rem 1.6rem;
        border-radius: .4rem;
        display: inline-block;
        margin: 1.2rem 0 .64rem;
        @media screen and (max-width: module.$tab){
          position: absolute;
          top: 0;
          left: 0;
          margin: 0;
        }
      }
    }
    .next{
      margin: 2.4rem 0 0;
      border-bottom: module.$normal 1px solid;
      width: 100%;
      font-size: 1.12rem;
      position: relative;
      @media screen and (max-width: module.$tab){
        display: none;
      }
      &:before{
        content: '';
        width: 6.4rem;
        background: module.$base;
        height: 1px;
        position: absolute;
        bottom: -1px;
        left: 0;
        transition: width 200ms module.$ease;
      }
      svg{
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    link: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
    cate: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
  }
}
</script>
